import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { BsFillTrash3Fill } from "react-icons/bs";
import { ISubject } from "../../../common/types";

interface deleteSubjectConfirmationProps {
  onDeleteConfirm: (id: number) => Promise<void>;
  subject: ISubject;
}

const SubjectDeleteConfirmation: React.FC<deleteSubjectConfirmationProps> = ({
  onDeleteConfirm,
  subject,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const handleDeleteClick = () => {
    setShowModal(true);
  };

  const handleConfirm = () => {
    onDeleteConfirm(subject.id);
    setShowModal(false);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <BsFillTrash3Fill
        style={{ color: "darkred", cursor: "pointer" }}
        onClick={() => {
          handleDeleteClick();
        }}
        title={"Obriši predmet"}
      />

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Potvrdi brisanje predmeta</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Jeste li sigurni da želite obrisati predmet{" "}
          <strong>{subject.name}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary" onClick={handleClose}>
            Odustani
          </Button>
          <Button onClick={handleConfirm}>Obriši</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SubjectDeleteConfirmation;
